import React, { useState, JSX } from 'react';
import { Button, Col, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import AdditionalContent from './AdditionalContent';

const AdditionalContentMobileView = ({
  additionalContentHeader,
  hasFilters,
  additionalContent
}: {
  additionalContentHeader?: string;
  hasFilters: boolean;
  additionalContent?: Array<{ id: number; component: JSX.Element }>;
}): JSX.Element => {
  const [contentOpen, setContentOpen] = useState<boolean>(false);

  const toggleAdditionalContentState = (): void => {
    const value = !contentOpen;
    setContentOpen(value);
  };

  return (
    <div className="w-100">
      <Button
        className="text-white btn-block my-2 font-weight-bold text-uppercase"
        color="primary"
        onClick={toggleAdditionalContentState}
      >
        <div className="justify-content-center">
          <span className="mr-2">{additionalContentHeader}</span>
          <span>
            {!contentOpen && <FontAwesomeIcon icon={faAngleDown} className="fas fa-lg" />}
            {contentOpen && <FontAwesomeIcon icon={faAngleUp} className="fas fa-lg" />}
          </span>
        </div>
      </Button>

      <Collapse isOpen={contentOpen}>
        <Col className="border border-dark pb-1">
          <br />
          <AdditionalContent hasFilters={hasFilters} additionalContent={additionalContent} />
        </Col>
      </Collapse>
    </div>
  );
};

export default AdditionalContentMobileView;
